import React from 'react';
import { UserPlus } from 'lucide-react';
import Modal from './modals/Modal';

interface RegistrationPromptProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
  message?: string;
}

export default function RegistrationPrompt({
  isOpen,
  onClose,
  onLogin,
  message = "To access all app features, you need to create an account."
}: RegistrationPromptProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create an Account"
    >
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <UserPlus className="w-8 h-8 text-blue-600" />
          <p className="text-gray-600">{message}</p>
        </div>

        <div className="space-y-4">
          <p className="text-gray-600">
            By creating an account, you will have access to:
          </p>

          <ul className="space-y-2 text-gray-600">
            <li className="flex items-start">
              <span className="text-blue-600 mr-2">•</span>
              Propose games and invite other players
            </li>
            <li className="flex items-start">
              <span className="text-blue-600 mr-2">•</span>
              Join existing games
            </li>
            <li className="flex items-start">
              <span className="text-blue-600 mr-2">•</span>
              Manage your availabilities
            </li>
            <li className="flex items-start">
              <span className="text-blue-600 mr-2">•</span>
              Receive notifications about your games
            </li>
          </ul>

          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:text-gray-900"
            >
              Not now
            </button>
            <button
              onClick={onLogin}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Login / Register
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}